import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React from 'react';
import { getSafeId } from '@mantine/utils';
import { useId, useUncontrolled } from '@mantine/hooks';
import { AccordionContextProvider } from './Accordion.context.js';
import { ACCORDION_ERRORS } from './Accordion.errors.js';
function AccordionProvider(_ref) {
  var children = _ref.children,
    multiple = _ref.multiple,
    value = _ref.value,
    defaultValue = _ref.defaultValue,
    onChange = _ref.onChange,
    id = _ref.id,
    loop = _ref.loop,
    transitionDuration = _ref.transitionDuration,
    disableChevronRotation = _ref.disableChevronRotation,
    chevronPosition = _ref.chevronPosition,
    chevronSize = _ref.chevronSize,
    order = _ref.order,
    chevron = _ref.chevron,
    variant = _ref.variant,
    radius = _ref.radius;
  var uid = useId(id);
  var _useUncontrolled = useUncontrolled({
      value: value,
      defaultValue: defaultValue,
      finalValue: multiple ? [] : null,
      onChange: onChange
    }),
    _useUncontrolled2 = _slicedToArray(_useUncontrolled, 2),
    _value = _useUncontrolled2[0],
    handleChange = _useUncontrolled2[1];
  var isItemActive = function isItemActive(itemValue) {
    return Array.isArray(_value) ? _value.includes(itemValue) : itemValue === _value;
  };
  var handleItemChange = function handleItemChange(itemValue) {
    var nextValue = Array.isArray(_value) ? _value.includes(itemValue) ? _value.filter(function (selectedValue) {
      return selectedValue !== itemValue;
    }) : [].concat(_toConsumableArray(_value), [itemValue]) : itemValue === _value ? null : itemValue;
    handleChange(nextValue);
  };
  return /* @__PURE__ */React.createElement(AccordionContextProvider, {
    value: {
      isItemActive: isItemActive,
      onChange: handleItemChange,
      getControlId: getSafeId("".concat(uid, "-control"), ACCORDION_ERRORS.value),
      getRegionId: getSafeId("".concat(uid, "-panel"), ACCORDION_ERRORS.value),
      transitionDuration: transitionDuration,
      disableChevronRotation: disableChevronRotation,
      chevronPosition: chevronPosition,
      chevronSize: chevronSize,
      order: order,
      chevron: chevron,
      loop: loop,
      variant: variant,
      radius: radius
    }
  }, children);
}
export { AccordionProvider };